import React from 'react'
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useNavigate } from 'react-router-dom';
import AvatarPic from '../../assets/images/avtarPic.png';
import SendIcon from '@mui/icons-material/Send';
import CloseIcon from '@mui/icons-material/Close';
import CreateIcon from "@mui/icons-material/Create";
import LocalPhoneIcon from "@mui/icons-material/LocalPhone";

function MobileSupportTicketDetails() {
    const navigate = useNavigate();
  return (
    <div className='mainWrapperView'>
     <div className='marginHorizontalCommon'>
      <div className="drawerWithTop">
        {/* <MobileDrawer /> */}
        <ArrowBackIcon
        className="backArrowMobil"
        onClick={() => navigate("/SupportTicket")}
        />
        <h1>Complaints Details</h1>
      </div>
      <div className='topSpace'></div>
      <div className="famDetailsListInrMob">
        <div style={{display:'flex', flexDirection:'column'}}>
        <div className="famDetailsListTo">
          <div className='tagInvoiceView paidTagView'>
            <p className='tagInvoiceTxt paidColor'>Ticket No T 101</p>
          </div>
          <div className="listDeleEdiMob">
            <CreateIcon style={{ color: "#21bd21" }} />
          <div className='tagInvoiceView'>
            <CloseIcon style={{ color: "#ff5252" }} />
            <p className='tagInvoiceTxt'>Close Ticket</p>
          </div>
          </div>
        </div>
        <div className="famDetailsListTo margineTopAdd">
          <div className="alignfamDetailsListToPro" onClick={()=> navigate('/MobileSupportTicketDetails')}>
            <div className="ImageViewRound">
              <img src={AvatarPic} alt="altimg"/>
            </div>
            <div className="detailsDiMob">
              <h1>User Name</h1>
              <div className="mobWithIco">
                <LocalPhoneIcon />
                <p>9881789836</p>
              </div>
            </div>
          </div>
          <div>
          <p className='ticketTimedeteTxt'>Time & Date</p>
          <p className='pollTimeTxt'>20/07/2024 10:30 Am</p>
          </div>
        </div>
        <div className='dividerCommon' />
        <div className='pollsTitlDescView' onClick={()=> navigate('/MobileSupportTicketDetails')}>
          <p className='pollsTitleTxt'>Polls Title Polls Title</p>
          <p className='pollsDescripTxt'>Polls Description Polls Description Polls Description Polls Description</p>
        </div>
        </div>
        </div>
        <div className='ChatView1'>
        <div className="famDetailsListTo">
          <div className="alignfamDetailsListToPro">
            <div className="ImageViewRound">
              <img src={AvatarPic} alt="altimg"/>
            </div>
            <div className="detailsDiMob">
              <h1>Fname Lname</h1>
              <div className="mobWithIco">
                <p>11/12/2024</p>
              </div>
            </div>
          </div>
         </div>
        <div className='dividerCommon' />
        <p className='descriptionComplainDetails'>
            Description Description Description Description Description Description
            </p>
        </div>
        <div className='ChatView2'>
        <div className="famDetailsListTo textAlignEnd">
          <div className="alignfamDetailsListToPro ">
            <div className="detailsDiMob textAlignEnd">
              <h1>Fname Lname</h1>
              <div className="mobWithIco">
                <p>11/12/2024</p>
              </div>
            </div>
            <div className="ImageViewRound">
              <img src={AvatarPic} alt="altimg"/>
            </div>
          </div>
         </div>
        <div className='dividerCommon' />
        <p className='descriptionComplainDetails'>
            Description Description Description Description Description Description
            </p>
        </div>
        </div>
        <div className='chatInputBoxView'>
            <input type='text' placeholder='Enter Message Here' className='chatInputBox'/>
            <SendIcon sx={{fontSize:35, color:'#005aff'}} />
        </div>
    </div>
  )
}

export default MobileSupportTicketDetails